var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6839,
    height: 6839,
    viewBox: "0 0 6839 6839",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3419.5 6839C5308.04 6839 6839 5308.04 6839 3419.5C6839 1530.96 5308.04 0 3419.5 0C1530.96 0 0 1530.96 0 3419.5C0 5308.04 1530.96 6839 3419.5 6839Z",
    fill: "#FF7278"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3419.5 6444.44C5090.13 6444.44 6444.44 5090.13 6444.44 3419.5C6444.44 1748.87 5090.13 394.56 3419.5 394.56C1748.87 394.56 394.56 1748.87 394.56 3419.5C394.56 5090.13 1748.87 6444.44 3419.5 6444.44Z",
    fill: "#FF6067"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3419.5 6049.88C4872.22 6049.88 6049.88 4872.22 6049.88 3419.5C6049.88 1966.78 4872.22 789.12 3419.5 789.12C1966.78 789.12 789.12 1966.78 789.12 3419.5C789.12 4872.22 1966.78 6049.88 3419.5 6049.88Z",
    fill: "#FF5057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3419.5 5655.33C4654.31 5655.33 5655.33 4654.31 5655.33 3419.5C5655.33 2184.69 4654.31 1183.67 3419.5 1183.67C2184.69 1183.67 1183.67 2184.69 1183.67 3419.5C1183.67 4654.31 2184.69 5655.33 3419.5 5655.33Z",
    fill: "#FF333B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3432.65 5260.77C4427.76 5260.77 5234.46 4436.41 5234.46 3419.5C5234.46 2402.6 4427.76 1578.23 3432.65 1578.23C2437.54 1578.23 1630.84 2402.6 1630.84 3419.5C1630.84 4436.41 2437.54 5260.77 3432.65 5260.77Z",
    fill: "#EC1C24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4355 2751.27L4087.73 2484L3419.5 3152.23L2751.27 2484L2484 2751.27L3152.23 3419.5L2484 4087.73L2751.27 4355L3419.5 3686.77L4087.73 4355L4355 4087.73L3686.77 3419.5L4355 2751.27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessRed);
export default __webpack_public_path__ + "static/media/success_red.04d20268f68eebcde212e2663f66160d.svg";
export { ForwardRef as ReactComponent };